import React from 'react'
import { IconButton, Button, Grid, Tooltip, Typography } from '@material-ui/core'
import { Card, CardDeck, Col, Row } from 'react-bootstrap'
import GrainIcon from '@material-ui/icons/Grain'
import SaveAltIcon from '@material-ui/icons/SaveAlt'
import LocalGasStationOutlinedIcon from '@material-ui/icons/LocalGasStationOutlined'
import LinearScaleIcon from '@material-ui/icons/LinearScale'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import LinkOffIcon from '@material-ui/icons/LinkOff'
import LinkIcon from '@material-ui/icons/Link'

export const OperacionesEnSiloView = ({
  silo: { estado, nombreCorto, nombre },
  openDialogOperacionesMovimientosSilo,
  openDialogOperacionesFumigadoSilo,
  openDialogOperacionesCubicajeSilo,
  openDialogOperacionesTransileSilo,
  cancelar,
  cambiarEstado
}) => (
  <Grid container direction='column' justify='space-around' spacing={2} alignItems='center'>
    <Grid item xs={12}>
      <Typography variant='h6'>Operaciones disponibles para silo <strong>{nombreCorto}</strong> <em>("{nombre}")</em></Typography>
    </Grid>
    <CardDeck className='justify-content-center'>
      <Card bg='light' text='dark' style={{ width: '12rem' }}
        onContextMenu={e => e.preventDefault()}
        onClick={(estado !== 'D') ? openDialogOperacionesMovimientosSilo : null}>
        <Card.Body >
          <Card.Title style={{ fontSize: '1.1em' }}><strong>Movimientos</strong></Card.Title>
          <Row className='d-flex align-items-center justify-content-center'>
            <Tooltip title={'Movimiento de granos'}>
              <span>
                <IconButton
                  onClick={openDialogOperacionesMovimientosSilo}
                  disabled={estado === 'D'}
                  sx={{ p: 0 }}>
                  <GrainIcon fontSize={'large'} color='primary' />
                </IconButton>
              </span>
            </Tooltip>
          </Row>
          {(estado === 'D') && <Card.Text
            className='text-muted'
            style={{ fontSize: '0.8em', textAlign: 'center' }}>
              No disponible
          </Card.Text>}
        </Card.Body>
      </Card>
      <Card bg='light' text='dark' style={{ width: '12rem' }}
        onContextMenu={e => e.preventDefault()}
        onClick={(estado === 'U') ? openDialogOperacionesCubicajeSilo : null}>
        <Card.Body >
          <Card.Title style={{ fontSize: '1.1em' }}><strong>Cubicaje</strong></Card.Title>
          <Row className='d-flex align-items-center justify-content-center'>
            <Tooltip title={'Cubicaje de silo'}>
              <span>
                <IconButton
                  onClick={openDialogOperacionesCubicajeSilo}
                  disabled={estado !== 'U'}
                  sx={{ p: 0 }}>
                  <SaveAltIcon fontSize={'large'} color='primary' />
                </IconButton>
              </span>
            </Tooltip>
          </Row>
          {(estado !== 'U') && <Card.Text
            className='text-muted'
            style={{ fontSize: '0.8em', textAlign: 'center' }}>
              No disponible
          </Card.Text>}
        </Card.Body>
      </Card>
      <Card bg='light' text='dark' style={{ width: '12rem' }}
        onContextMenu={e => e.preventDefault()}
        onClick={((estado === 'U' || estado === 'L')) ? openDialogOperacionesFumigadoSilo : null}>
        <Card.Body >
          <Card.Title style={{ fontSize: '1.1em' }}><strong>Fumigado</strong></Card.Title>
          <Row className='d-flex align-items-center justify-content-center'>
            <Tooltip title={'Fumigado de silo'}>
              <span>
                <IconButton
                  onClick={openDialogOperacionesFumigadoSilo}
                  disabled={estado !== 'U' && estado !== 'L'}
                  sx={{ p: 0 }}>
                  <LocalGasStationOutlinedIcon fontSize={'large'} color='primary' />
                </IconButton>
              </span>
            </Tooltip>
          </Row>
          {(estado !== 'U' && estado !== 'L') && <Card.Text
            className='text-muted'
            style={{ fontSize: '0.8em', textAlign: 'center' }}>
              No disponible
          </Card.Text>}
        </Card.Body>
      </Card>
      <Card bg='light' text='dark' style={{ width: '12rem' }}
        onContextMenu={e => e.preventDefault()}
        onClick={(estado === 'U') ? openDialogOperacionesTransileSilo : null}>
        <Card.Body >
          <Card.Title style={{ fontSize: '1.1em' }}><strong>Transile</strong></Card.Title>
          <Row className='d-flex align-items-center justify-content-center'>
            <Tooltip title={'Transile'}>
              <span>
                <IconButton
                  onClick={openDialogOperacionesTransileSilo}
                  disabled={estado !== 'U'}
                  sx={{ p: 0 }}>
                  <LinearScaleIcon fontSize={'large'} color='primary' />
                </IconButton>
              </span>
            </Tooltip>
          </Row>
          {(estado !== 'U') && <Card.Text
            className='text-muted'
            style={{ fontSize: '0.8em', textAlign: 'center' }}>
              No disponible
          </Card.Text>}
        </Card.Body>
      </Card>
    </CardDeck>
    {/* {estado !== 'D' && ( */}
    <Grid item>
      {/* <Button
        color='primary'
        variant='contained'
        disabled={estado === 'D'}
        onClick={openDialogOperacionesMovimientosSilo}>
          Movimientos
      </Button> */}
    </Grid>
    {/* )} */}
    {/* {estado === 'U' && ( */}
    <Grid item>
      {/* <Button
        color='primary'
        variant='contained'
        disabled={estado !== 'U'}
        onClick={openDialogOperacionesCubicajeSilo}>
          Cubicajes
      </Button> */}
    </Grid>
    {/* )} */}
    {/* {(estado === 'U' || estado === 'L') && ( */}
    <Grid item>
      {/* <Button
        color='primary'
        variant='contained'
        disabled={estado !== 'U' && estado !== 'L'}
        onClick={openDialogOperacionesFumigadoSilo}>
          Fumigado
      </Button> */}
    </Grid>
    {/* )} */}
    {/* {estado === 'U' && ( */}
    <Grid item>
      {/* <Button
        color='primary'
        variant='contained'
        disabled={estado !== 'U'}
        onClick={openDialogOperacionesTransileSilo}>
          Transile
      </Button> */}
    </Grid>
    {/* )} */}
    <Grid container item spacing={2} justify='flex-end'>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Col xs={4}>
          <Button
            color='primary'
            variant='contained'
            startIcon={(estado === 'D') ? <LinkIcon /> : <LinkOffIcon />}
            onClick={cambiarEstado}>
            {(estado === 'D') ? 'Habilitar' : 'Deshabilitar'}
          </Button>
        </Col>
        <Col xs={2} />
        <Col xs={4}>
          <Button
            color='primary'
            variant='contained'
            startIcon={<HighlightOffIcon />}
            onClick={cancelar}>
            Cerrar
          </Button>
        </Col>
      </div>
    </Grid>
  </Grid>
)
